/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createJobNote = /* GraphQL */ `
  mutation CreateJobNote(
    $input: CreateJobNoteInput!
    $condition: ModelJobNoteConditionInput
  ) {
    createJobNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      sharedWith
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const updateJobNote = /* GraphQL */ `
  mutation UpdateJobNote(
    $input: UpdateJobNoteInput!
    $condition: ModelJobNoteConditionInput
  ) {
    updateJobNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      sharedWith
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const deleteJobNote = /* GraphQL */ `
  mutation DeleteJobNote(
    $input: DeleteJobNoteInput!
    $condition: ModelJobNoteConditionInput
  ) {
    deleteJobNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      sharedWith
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const createNote = /* GraphQL */ `
  mutation CreateNote(
    $input: CreateNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    createNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const updateNote = /* GraphQL */ `
  mutation UpdateNote(
    $input: UpdateNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    updateNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const deleteNote = /* GraphQL */ `
  mutation DeleteNote(
    $input: DeleteNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    deleteNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const createSharedNote = /* GraphQL */ `
  mutation CreateSharedNote(
    $input: CreateSharedNoteInput!
    $condition: ModelSharedNoteConditionInput
  ) {
    createSharedNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const updateSharedNote = /* GraphQL */ `
  mutation UpdateSharedNote(
    $input: UpdateSharedNoteInput!
    $condition: ModelSharedNoteConditionInput
  ) {
    updateSharedNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const deleteSharedNote = /* GraphQL */ `
  mutation DeleteSharedNote(
    $input: DeleteSharedNoteInput!
    $condition: ModelSharedNoteConditionInput
  ) {
    deleteSharedNote(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const createPart = /* GraphQL */ `
  mutation CreatePart(
    $input: CreatePartInput!
    $condition: ModelPartConditionInput
  ) {
    createPart(input: $input, condition: $condition) {
      id
      dateOrdered
      quantity
      partOrdered
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const updatePart = /* GraphQL */ `
  mutation UpdatePart(
    $input: UpdatePartInput!
    $condition: ModelPartConditionInput
  ) {
    updatePart(input: $input, condition: $condition) {
      id
      dateOrdered
      quantity
      partOrdered
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const deletePart = /* GraphQL */ `
  mutation DeletePart(
    $input: DeletePartInput!
    $condition: ModelPartConditionInput
  ) {
    deletePart(input: $input, condition: $condition) {
      id
      dateOrdered
      quantity
      partOrdered
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const createClient = /* GraphQL */ `
  mutation CreateClient(
    $input: CreateClientInput!
    $condition: ModelClientConditionInput
  ) {
    createClient(input: $input, condition: $condition) {
      id
      title
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      sendBy
      serviceCallNotes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      contacts {
        items {
          id
          name
          position
          phone
          mobile
          fax
          email
          contactClientId
          deactivated
        }
        nextToken
      }
      products {
        items {
          id
          title
          productClientId
        }
        nextToken
      }
    }
  }
`;
export const updateClient = /* GraphQL */ `
  mutation UpdateClient(
    $input: UpdateClientInput!
    $condition: ModelClientConditionInput
  ) {
    updateClient(input: $input, condition: $condition) {
      id
      title
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      sendBy
      serviceCallNotes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      contacts {
        items {
          id
          name
          position
          phone
          mobile
          fax
          email
          contactClientId
          deactivated
        }
        nextToken
      }
      products {
        items {
          id
          title
          productClientId
        }
        nextToken
      }
    }
  }
`;
export const deleteClient = /* GraphQL */ `
  mutation DeleteClient(
    $input: DeleteClientInput!
    $condition: ModelClientConditionInput
  ) {
    deleteClient(input: $input, condition: $condition) {
      id
      title
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      sendBy
      serviceCallNotes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      contacts {
        items {
          id
          name
          position
          phone
          mobile
          fax
          email
          contactClientId
          deactivated
        }
        nextToken
      }
      products {
        items {
          id
          title
          productClientId
        }
        nextToken
      }
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      name
      position
      phone
      mobile
      fax
      email
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      contactClientId
      deactivated
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      name
      position
      phone
      mobile
      fax
      email
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      contactClientId
      deactivated
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      name
      position
      phone
      mobile
      fax
      email
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      contactClientId
      deactivated
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      title
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      productClientId
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      title
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      productClientId
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      title
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      productClientId
    }
  }
`;
export const createSupplier = /* GraphQL */ `
  mutation CreateSupplier(
    $input: CreateSupplierInput!
    $condition: ModelSupplierConditionInput
  ) {
    createSupplier(input: $input, condition: $condition) {
      id
      title
      dateCreated
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      deliveryAddress
      deliverySuburb
      deliveryState
      deliveryPostcode
      notes
      jobsSentBy
      agreementReturned
      insuranceExpires
      # ratePerHour
      username
      password
      postcodes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      deactivated
    }
  }
`;
export const updateSupplier = /* GraphQL */ `
  mutation UpdateSupplier(
    $input: UpdateSupplierInput!
    $condition: ModelSupplierConditionInput
  ) {
    updateSupplier(input: $input, condition: $condition) {
      id
      title
      dateCreated
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      deliveryAddress
      deliverySuburb
      deliveryState
      deliveryPostcode
      notes
      jobsSentBy
      agreementReturned
      insuranceExpires
      # ratePerHour
      username
      password
      postcodes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      deactivated
    }
  }
`;
export const deleteSupplier = /* GraphQL */ `
  mutation DeleteSupplier(
    $input: DeleteSupplierInput!
    $condition: ModelSupplierConditionInput
  ) {
    deleteSupplier(input: $input, condition: $condition) {
      id
      title
      dateCreated
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      deliveryAddress
      deliverySuburb
      deliveryState
      deliveryPostcode
      notes
      jobsSentBy
      agreementReturned
      insuranceExpires
      # ratePerHour
      username
      password
      postcodes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      deactivated
    }
  }
`;
export const createJob = /* GraphQL */ `
  mutation CreateJob(
    $input: CreateJobInput!
    $condition: ModelJobConditionInput
  ) {
    createJob(input: $input, condition: $condition) {
      id
      jobNr
      jobNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
          sharedWith
        }
        nextToken
      }
      notes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      sharedNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      parts {
        items {
          id
          dateOrdered
          quantity
          partOrdered
        }
        nextToken
      }
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      jobClientId
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      jobSupplierId
      startDate
      dueDate
      clientRef
      name
      description
      closed
      priority
      clientOrderNumber
      contact1
      contact2
      product
      quantity
      product2
      quantity2
      licenseNr
      serviceAgent
      phone
      mobile
      fax
      other
      email
      address
      townSuburb
      state
      postcode
      proofOfPurchase
      datePurchased
      purchasedFrom
      builderInstall
      contactNr
      finalKpa
      status
      faultInformation
      checklist
      inspect
      partsToCustomer
      photosRequired
      pickup
      service
      vanStock
      followUp
      completionNote
    }
  }
`;
export const updateJob = /* GraphQL */ `
  mutation UpdateJob(
    $input: UpdateJobInput!
    $condition: ModelJobConditionInput
  ) {
    updateJob(input: $input, condition: $condition) {
      id
      jobNr
      jobNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
          sharedWith
        }
        nextToken
      }
      notes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      sharedNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      parts {
        items {
          id
          dateOrdered
          quantity
          partOrdered
        }
        nextToken
      }
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      jobClientId
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      jobSupplierId
      startDate
      dueDate
      clientRef
      name
      description
      closed
      priority
      clientOrderNumber
      contact1
      contact2
      product
      quantity
      product2
      quantity2
      licenseNr
      serviceAgent
      phone
      mobile
      fax
      other
      email
      address
      townSuburb
      state
      postcode
      proofOfPurchase
      datePurchased
      purchasedFrom
      builderInstall
      contactNr
      finalKpa
      status
      faultInformation
      checklist
      inspect
      partsToCustomer
      photosRequired
      pickup
      service
      vanStock
      followUp
      completionNote
    }
  }
`;
export const deleteJob = /* GraphQL */ `
  mutation DeleteJob(
    $input: DeleteJobInput!
    $condition: ModelJobConditionInput
  ) {
    deleteJob(input: $input, condition: $condition) {
      id
      jobNr
      jobNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
          sharedWith
        }
        nextToken
      }
      notes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      sharedNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      parts {
        items {
          id
          dateOrdered
          quantity
          partOrdered
        }
        nextToken
      }
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      jobClientId
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      jobSupplierId
      startDate
      dueDate
      clientRef
      name
      description
      closed
      priority
      clientOrderNumber
      contact1
      contact2
      product
      quantity
      product2
      quantity2
      licenseNr
      serviceAgent
      phone
      mobile
      fax
      other
      email
      address
      townSuburb
      state
      postcode
      proofOfPurchase
      datePurchased
      purchasedFrom
      builderInstall
      contactNr
      finalKpa
      status
      faultInformation
      checklist
      inspect
      partsToCustomer
      photosRequired
      pickup
      service
      vanStock
      followUp
      completionNote
    }
  }
`;
export const createJobStatus = /* GraphQL */ `
  mutation CreateJobStatus(
    $input: CreateJobStatusInput!
    $condition: ModelJobStatusConditionInput
  ) {
    createJobStatus(input: $input, condition: $condition) {
      id
      title
      bgColor
      fgColor
      completesJob
    }
  }
`;
export const updateJobStatus = /* GraphQL */ `
  mutation UpdateJobStatus(
    $input: UpdateJobStatusInput!
    $condition: ModelJobStatusConditionInput
  ) {
    updateJobStatus(input: $input, condition: $condition) {
      id
      title
      bgColor
      fgColor
      completesJob
    }
  }
`;
export const deleteJobStatus = /* GraphQL */ `
  mutation DeleteJobStatus(
    $input: DeleteJobStatusInput!
    $condition: ModelJobStatusConditionInput
  ) {
    deleteJobStatus(input: $input, condition: $condition) {
      id
      title
      bgColor
      fgColor
      completesJob
    }
  }
`;
export const createJobPriority = /* GraphQL */ `
  mutation CreateJobPriority(
    $input: CreateJobPriorityInput!
    $condition: ModelJobPriorityConditionInput
  ) {
    createJobPriority(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const updateJobPriority = /* GraphQL */ `
  mutation UpdateJobPriority(
    $input: UpdateJobPriorityInput!
    $condition: ModelJobPriorityConditionInput
  ) {
    updateJobPriority(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const deleteJobPriority = /* GraphQL */ `
  mutation DeleteJobPriority(
    $input: DeleteJobPriorityInput!
    $condition: ModelJobPriorityConditionInput
  ) {
    deleteJobPriority(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const createJobFaultType = /* GraphQL */ `
  mutation CreateJobFaultType(
    $input: CreateJobFaultTypeInput!
    $condition: ModelJobFaultTypeConditionInput
  ) {
    createJobFaultType(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const updateJobFaultType = /* GraphQL */ `
  mutation UpdateJobFaultType(
    $input: UpdateJobFaultTypeInput!
    $condition: ModelJobFaultTypeConditionInput
  ) {
    updateJobFaultType(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const deleteJobFaultType = /* GraphQL */ `
  mutation DeleteJobFaultType(
    $input: DeleteJobFaultTypeInput!
    $condition: ModelJobFaultTypeConditionInput
  ) {
    deleteJobFaultType(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const createNoteContactType = /* GraphQL */ `
  mutation CreateNoteContactType(
    $input: CreateNoteContactTypeInput!
    $condition: ModelNoteContactTypeConditionInput
  ) {
    createNoteContactType(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const updateNoteContactType = /* GraphQL */ `
  mutation UpdateNoteContactType(
    $input: UpdateNoteContactTypeInput!
    $condition: ModelNoteContactTypeConditionInput
  ) {
    updateNoteContactType(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const deleteNoteContactType = /* GraphQL */ `
  mutation DeleteNoteContactType(
    $input: DeleteNoteContactTypeInput!
    $condition: ModelNoteContactTypeConditionInput
  ) {
    deleteNoteContactType(input: $input, condition: $condition) {
      id
      title
      deactivated
    }
  }
`;
export const createJobAction = /* GraphQL */ `
  mutation CreateJobAction(
    $input: CreateJobActionInput!
    $condition: ModelJobActionConditionInput
  ) {
    createJobAction(input: $input, condition: $condition) {
      id
      jobId
      createdAt
      updatedAt
      action
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const updateJobAction = /* GraphQL */ `
  mutation UpdateJobAction(
    $input: UpdateJobActionInput!
    $condition: ModelJobActionConditionInput
  ) {
    updateJobAction(input: $input, condition: $condition) {
      id
      jobId
      createdAt
      updatedAt
      action
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const deleteJobAction = /* GraphQL */ `
  mutation DeleteJobAction(
    $input: DeleteJobActionInput!
    $condition: ModelJobActionConditionInput
  ) {
    deleteJobAction(input: $input, condition: $condition) {
      id
      jobId
      createdAt
      updatedAt
      action
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const createInvoice = /* GraphQL */ `
  mutation CreateInvoice(
    $input: CreateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    createInvoice(input: $input, condition: $condition) {
      id
      jobId
      createdAt
      updatedAt
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      invoiceNumber
      description
      amount
      clientAmount
      clientInvoiced
      t2InvoiceNumber
      t2Invoiced
    }
  }
`;
export const updateInvoice = /* GraphQL */ `
  mutation UpdateInvoice(
    $input: UpdateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    updateInvoice(input: $input, condition: $condition) {
      id
      jobId
      createdAt
      updatedAt
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      invoiceNumber
      description
      amount
      clientAmount
      clientInvoiced
      t2InvoiceNumber
      t2Invoiced
    }
  }
`;
export const deleteInvoice = /* GraphQL */ `
  mutation DeleteInvoice(
    $input: DeleteInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    deleteInvoice(input: $input, condition: $condition) {
      id
      jobId
      createdAt
      updatedAt
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      invoiceNumber
      description
      amount
      clientAmount
      clientInvoiced
      t2InvoiceNumber
      t2Invoiced
    }
  }
`;
